var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pv-trend-icon",attrs:{"type":"button","title":_vm._f("translate")('출력량 추이')},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v("mdi-chart-line")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }